<template>
  <div id="app">
    
    <div class="RightContainer">
      <div class="MapboxContainer">
        <Mapbox ref="map" />
      </div>
      <!-- <div class="SidePanelContainer">
        <SidePanel />
      </div> -->
      <div class="FooterContainer">
        <Footer />
      </div>
      <div class="TagNavContainer">
        <TagNavPanel />
      </div>
      <div class="LogoContainer" @click="handleLogoClick">
        De Renovatieversneller Monitor
      </div>
    </div>
    <div 
      class="MainPanelContainer"
      :class="MainPanelClassList" >
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>

import Footer from './components/layout/Footer'
import Mapbox from './components/mapbox/Mapbox'
// import SidePanel from './components/layout/SidePanel'
import TagNavPanel from './components/layout/TagNavPanel'

import { getDataSet } from '@/scripts/generate_dataset.js'

import { mapMutations } from 'vuex'

export default {
  name: 'App',
  components: {
    Footer,
    Mapbox,
    // SidePanel,
    TagNavPanel
  },
  computed: {
    MainPanelClassList() {
      return {
        'MainPanelContainer--wide' : this.$store.state.extended
      }
    }
  },
  created() {
    getDataSet(this.processData)
  },
  methods: {
    ...mapMutations(['setDataset', 'setPartijen', 'setProjects', 'setThemas']),
    processData(err, response) {
      if (err) {
        throw new Error('Problem loading data')
      } 
      let dataset = JSON.parse(response.body)
      this.setDataset({ dataset })
      this.setProjects({ dataset })
      this.setPartijen({ dataset })
      this.setThemas({ dataset })
    },
    handleLogoClick() {
      
      // Call method on MapBox component
      // TODO: Implement a better solution
      this.$refs.map.zoomToAllProjects()

      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss">

  @import './assets/sass/main.scss';

  html, body, #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  html {
    -ms-content-zooming: none;
    -ms-touch-action: pan-x pan-y;
  }

  *, :after, :before {
    box-sizing: border-box;
    flex-shrink: 0;
  }

  #app {
    display: flex
  }

  .RightContainer, .MainPanelContainer {
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .RightContainer, .MapboxContainer {
    flex: 0 1 auto;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .MainPanelContainer {
    width: 480px; // compact
    flex: none;
    // border-left: 1px solid $gray_mid;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    box-shadow: 0 0.125rem 0.8125rem rgba(0, 0, 0, 0.28);
    opacity: 0.99;

    &--wide {
      width: 800px;
    }
  }

  .FooterContainer {
    flex: none;
  }

  .LogoContainer {
    position: absolute;
    top:0;
    left: 0;
    // top: 12px;
    // left: -80px;
    background: $color_primary;
    padding: 24px 100px;
    // transform: rotateZ(-36deg);
    letter-spacing: 0.9px;
    box-shadow: 0 0.125rem 0.8125rem rgba(0, 0, 0, 0.28);
    text-align: center;
    line-height: 1.2;
    font-family: $font_header;
    font-size: 24px;
    color: white;
    user-select: none;
    cursor: pointer;

    a {
      color: white;
      text-decoration: none;
    }
  }
  


</style>



<!-- <style lang="scss">
// #app {
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }
// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style> -->
